import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import VisuallyHidden from '@wix/da-a11y/pkg/components/VisuallyHidden';
import SubmissionDetails from '../../../SubmissionDetails';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import JournalViewer from '../../../DaEditorWrapper/Viewer/Journal';
import TextRenderer from '../../../TextRenderer';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import { useDeviationViewContext } from '../../../Context/DeviationViewContext';
import SubPaywall from '../../../DeviationViews/Full/_partials/SubPaywall';
import TextContent from '../../Details/_partials/TextContent';
import StatBlock from '../../Details/_partials/StatBlock';
import PremiumCover from '../_partials/PremiumCover';
import s from './Literature.scss';
const LiteratureContent = ({ deviation: { textContent }, deviation, withArtist = true })=>{
    var _deviation;
    const { t } = useTranslation();
    const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    const { isPremiumLocked } = normalizePremiumFolderData((_deviation = deviation) === null || _deviation === void 0 ? void 0 : _deviation.premiumFolderData);
    const isMobile = useContext(MobileContext);
    const { isSubscribedButBlocked, needsSubscription } = useSubscriptionTier(deviation);
    const isBlocked = needsSubscription || isSubscribedButBlocked;
    // only show here in full screen, otherwise it's shown in DesktopLayout in the left column
    const { isFullscreen } = useDeviationViewContext();
    const shouldShowFullscreenSubPaywall = isBlocked && isFullscreen;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, withArtist && /*#__PURE__*/ React.createElement("div", {
        className: s['author-block']
    }, /*#__PURE__*/ React.createElement(SubmissionDetails, {
        deviation: deviation
    }), !isMobile && ' '), /*#__PURE__*/ React.createElement(StatBlock, {
        className: s['stats'],
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(Section, {
        className: classnames(s['wrapper'], isPremiumLocked && s['wrapper-with-paywall'])
    }, /*#__PURE__*/ React.createElement(VisuallyHidden, null, /*#__PURE__*/ React.createElement(Heading, null, t('deviationview.literature.a11y.heading.content'))), !isBlocked && isExtendedLoaded && (isPremiumLocked ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(TextRenderer, {
        className: s['text-content-pf'],
        textContent: textContent,
        reactViewer: JournalViewer,
        viewerKey: deviation.deviationId,
        legacyTheme: "journal"
    }), /*#__PURE__*/ React.createElement(PremiumCover, {
        deviation: deviation
    })) : /*#__PURE__*/ React.createElement(TextContent, {
        className: s['text-content'],
        textContent: textContent,
        deviationId: deviation.deviationId
    })), shouldShowFullscreenSubPaywall && /*#__PURE__*/ React.createElement(SubPaywall, {
        className: s['paywall'],
        deviation: deviation,
        showImage: false
    })));
};
LiteratureContent.displayName = 'LiteratureContent';
export default LiteratureContent;
